import { Row, Col, Modal, Form, Input } from "antd";
import "react-phone-input-2/lib/style.css";
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
import lang from "../../helper/lang";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";

const AddFrom = ({
  path,
  sectionName,
  show,
  hide,
  data,
  refresh,
  isUpdate,
}) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!data) return;

    form.setFieldsValue({
      ...data,
      name: data?.name,
      rule: data?.rule,
    });
  }, [data]);

  const onCreate = (values) => {
    const { name, rule } = values;

    const payload = {
      name,
      rule,
    };

    setLoading(true);
    if (isUpdate) {
      request({
        url: `${apiPath.updateClipType}/${data._id}`,
        method: "PUT",
        data: payload,
        onSuccess: (data) => {
          setLoading(false);
          if (data.status) {
            ShowToast(data.message, Severty.SUCCESS);
            hide();
            refresh();
          } else {
            ShowToast(data.message, Severty.ERROR);
          }
        },
        onError: (error) => {
          ShowToast(error.response.data.message, Severty.ERROR);
          setLoading(false);
        },
      });
    } else {
      request({
        url: `${apiPath.addClipType}`,
        method: "POST",
        data: payload,
        onSuccess: (data) => {
          setLoading(false);
          if (data.status) {
            ShowToast(data.message, Severty.SUCCESS);
            hide();
            refresh();
          } else {
            ShowToast(data.message, Severty.ERROR);
          }
        },
        onError: (error) => {
          ShowToast(error.response.data.message, Severty.ERROR);
          setLoading(false);
        },
      });
    }
  };

  return (
    <Modal
      width={600}
      open={show}
      title={`${data
          ? lang("Update") + " " + sectionName
          : lang("Add") + " " + lang("New") + " " + sectionName
        }`}
      okText={`${data ? lang("Update") : lang("Add")}`}
      cancelText={
        <>
          <CloseOutlined style={{ marginRight: "8px" }} />
          {lang("Cancel")}
        </>
      }
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
        icon: <CheckOutlined />,
      }}
    >
      <Form
        id="create"
        form={form}
        initialValues={{ deal_in: "Products" }}
        onFinish={onCreate}
        layout="vertical"
      >
        <Row gutter={[16, 16]}>
          <Col span={24} lg={24}>
            <Form.Item
              className="mb-1"
              label={"ClipType Name"}
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please Enter The ClipType Name",
                },
              ]}
            >
              <Input placeholder="Enter The ClipType Name" />
            </Form.Item>
          </Col>
          <Col span={24} lg={24}>
            <Form.Item
              className="mb-1"
              label={"Rule"}
              name="rule"
              rules={[
                {
                  required: true,
                  message: "Please Enter The Rule",
                },
              ]}
            >
              <Input type="number" step="any" placeholder="Enter The Rule (e.g. 1 or 2.3)" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddFrom;
